import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useSeenFilter } from 'Components/VehicleList/SeenFilter';
import { snowplowUserGlobalContext } from 'Services/analytics/snowplowGlobalContext/userContext';
import { snowplowVehicleListGlobalContext } from 'Services/analytics/snowplowGlobalContext/vehicleListContext';
import { trackSnowplowPageView } from 'Services/snowplow';
import { useFilters, useVehicleCount } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useListType } from 'Stores/ListStore/ListStore';
import { useCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import type { User } from 'Types/user';
import useIsAuth from 'Utilities/hooks/useIsAuth';
import { VIEWING_FILTER } from 'Utilities/seenVehicles/seenVehicles';

interface AnalyticsGlobalContextProps {
	user?: User;
}

export const AnalyticsGlobalContext: React.FC<AnalyticsGlobalContextProps> = ({ user }) => {
	const listType = useListType();
	const { pathname } = useRouter();
	const filters = useFilters();
	const isAuth = useIsAuth();
	const currentFilter = useCurrentFilter();
	const numVehiclesMatched = useVehicleCount();
	const [seenFilter] = useSeenFilter();
	const hideViewedVehicles = seenFilter === VIEWING_FILTER.NEW;

	useEffect(() => {
		snowplowUserGlobalContext({ isAuth, user });
	}, [isAuth, user]);

	useEffect(() => {
		snowplowVehicleListGlobalContext({
			currentFilter,
			filters,
			hideViewedVehicles,
			listType,
			numVehiclesMatched,
			pathname,
		});
	}, [filters, listType, pathname, currentFilter, hideViewedVehicles, numVehiclesMatched]);

	useEffect(() => {
		trackSnowplowPageView();
	}, []);

	return null;
};
